// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__PVuMi","list":"Navbar_list__krmAR","item":"Navbar_item__+TAnQ"};